import { gql } from '@apollo/client';

export const BASE_COMPANY_USER_FRAGMENT = gql`
  fragment baseCompanyUserValues on CompanyUser {
    id
    firstName
    lastName
    email
    role
    telephoneNumber
    jobTitle
    department
    invitedTimestamp
    isRegistered
    fullName @client
    status @client
    isAdmin @client
  }
`;

export const COMPANY_USER_FRAGMENT = gql`
  fragment companyUserValues on CompanyUser {
    ...baseCompanyUserValues
    onboarding
    latestTermsAccepted
    notifications {
      weeklyRoundup
    }
  }
  ${BASE_COMPANY_USER_FRAGMENT}
`;
